import { useEffect, useState } from 'react';
import { Box, Typography, InputAdornment, styled } from '@mui/material';
import Dialog, { DialogPrimaryButton } from './Dialog';
import InputField from './InputField';
import DateField from './DateField';

const FieldStack = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  marginBottom: 28,
});

const VerifyDocumentAmountDialog = ({ open, onClose, onSave, saving }) => {
  const [amount, setAmount] = useState('');
  const [percentage, setPercentage] = useState('20');
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    if (!open) return;
    setAmount('');
    setPercentage('20');
    setSelectedDate(new Date());
  }, [open]);

  const handleClose = () => {
    setAmount('');
    setPercentage('20');
    setSelectedDate(new Date());
    onClose();
  };

  const handleSave = () => {
    onSave?.({ amount, percentage, date: selectedDate });
  };

  return (
    <Dialog open={open} onClose={handleClose} title="AJOUTER UN MONTANT">
      <FieldStack>
        <InputField
          label="Montant"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          type="number"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ color: '#ACACAC' }}>
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>€</Typography>
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-input': {
              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              MozAppearance: 'textfield',
            },
          }}
        />

        <DateField
          label="Date"
          value={selectedDate}
          onChange={setSelectedDate}
          placeholder="Sélectionner"
          sx={{
            width: '100%',
            alignSelf: 'stretch',
            '& > div:first-of-type': {
              width: '100%',
              maxWidth: '100%',
              minWidth: 0,
              boxSizing: 'border-box',
            },
          }}
        />

        <InputField
          label="Pourcentage"
          value={percentage}
          onChange={(e) => setPercentage(e.target.value)}
          type="number"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ color: '#ACACAC' }}>
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>%</Typography>
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-input': {
              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              MozAppearance: 'textfield',
            },
          }}
        />
      </FieldStack>
      <DialogPrimaryButton variant="contained" onClick={handleSave} disabled={saving}>
        ENREGISTRER
      </DialogPrimaryButton>
    </Dialog>
  );
};

export default VerifyDocumentAmountDialog;
